import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";

export const BuyBtn = styled(Button)({
  height: "48px",
  lineHeight: "48px",
  maxHeight: "48px",
  width: "100%",
  color: "#22D758",
  fontSize: 14,
  fontFamily: "Gill Sans",
  textTransform: "uppercase",
  background: "transparent",
  border: "1px solid",
  borderColor: "#22D758",
  borderRadius: "8px",
  ".browserIcon": {
    marginLeft: "12px",
  },
  "&:hover": {
    background: "rgba(34, 215, 88, 0.4)",
    color: "#22D758",
    ".browserIcon": {
      path: {
        fill: "#22D758",
        stroke: "#22D758",
      },
    },
  },
});
